import React, { Component } from 'react'
import { width } from 'window-size';
//import { fastest } from 'sw-toolbox';
import '../config'

export default class second extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile:false,
      data:
    [{
      title:'定制+智量',
      intro:'突破地理限制,延伸量体服务半径降低量体成本,节约30%量体成本净体尺寸,适用多品类定制的要求',
      img1:require('../image/dingzhi.svg'),
    },
    {
      title:'零售+智量',
      intro:'全新的门店智能量体终端充满科技感的量身定制体验线上线下全渠道服务顾客',
      img1:require('../image/lingshou.svg'),
    },
    {
      title:'电商+智量',
      intro:'高效获取海量用户精准身材数据精准匹配成衣尺码,自动推荐商品型号减少退换货比例,提高二次消费概率',
      img1:require('../image/dianshang.svg'),
    },
    {
      title:'体检+智量',
      intro:'完美适用于征兵、学生等体检工作快速、高效采集大批量人群身材数据自动生成电子表格,减少人工参与',
      img1:require('../image/solution-measure.svg'),
    },
  ],
  data01:[{
    title:'[智量]拍照量体服务',
    sub:'无处不在的量体服务',
    intro:'正常衣着,环境的情况下通过手机拍照,即可获取准确的身材数据;极大的量体服务效率及范围,帮你构建新的核心竞争力',
    img:require('../image/paizhao.svg')
    },
    {
    title:'[智量]智能量体终端',
    sub:'自带营销功能的量体设备',
    intro:'创新人体数据采集终端,可以极大的节省硬件投入成本.通过硬件+软件的创新结合,帮你快速进入新零售时代',
    img:require('../image/zhineng.svg')
    },
    {
    title:'[智量]智能量体终端',
    sub:'自带营销功能的量体设备',
    intro:'创新人体数据采集终端,可以极大的节省硬件投入成本.通过硬件+软件的创新结合,帮你快速进入新零售时代',
    img:require('../image/zaixiandingzhi.svg')
    }],
    data02:[{
      title:'更自然的量体体验',
      img:require('../image/youshi1.svg'),
      intro:[{
          sub:'衣着',
          intro01:'正常衣着的情况下，即可获取准确量体数据'},
          {
          sub:'姿态',
          intro01:'加入人体动态还原技术,在正常站姿下,即可完成量体'},
          {
          sub:'背景',
          intro01:'在复杂的背景,弱光情况下,也可完成拍照量体更广泛的应用场景'}
      ]},
      {
      title:'更广泛的应用场景',
      img:require('../image/youshi2.svg'),
      intro:[{
          sub:'准确',
          intro01:'行业领先的数据准确率，经过各行业应用检验'},
          {
          sub:'快速',
          intro01:'行业领先的数据准确率，经过各行业应用检验快速；对比传统量体方式，无需等待'},
          {
          sub:'方便',
          intro01:'提供云端、sdk、小程序、web等多种技术解决方案'}
      ]}
  ]
  }
}

  componentDidMount(){
  
  }
  render() {
    return (
      <div>
      {
        global.constants.isMobile&&
        <div className="first">
          <div className="title">
                解决方案
          </div>
          <div className="tag-container">
            {
              this.state.data.map((item,index)=>{
                return (
                  <div style={{borderBottom:(index===3?"0":"solid 0.01rem #c9c9c9")}} key={index} className="box" >
                    <img  src={item.img1} className="icon"/>
                    <div className="intro">
                      <div className="title02-1">{item.title}</div>
                      <div className="intro02-1">{item.intro}</div>
                    </div>
                    <div className="button01">
                      <img src={require('../image/jiantou.svg')} className="jiantou"></img>
                    </div>
                  </div>  
                );
              })
            }
          </div>
          <div  className="title">
                产品中心
          </div>
          <div className="tag-container">
            {
              this.state.data01.map((item,index)=>{
                return (
                  <div style={{borderBottom:(index===2?"0":"solid 0.01rem #c9c9c9")}} key={index} className="box" >
                    <img  style={{width:"6rem",margin:"0.5rem"}} src={item.img} className="icon"/>
                    <div style={{textAlign:"left"}} className="intro">
                      <div className="title02-1">{item.title}</div>
                      <div  style={{color:"rgb(68,126,235)"}} className="intro02-1">{item.sub}</div>
                      <div style={{color:"rgb(153,166,188)"}} className="intro02-1">{item.intro}</div>
                    </div>
                    <div className="button01">
                      <img src={require('../image/jiantou.svg')} className="jiantou"></img>
                    </div>
                  </div>  
                );
              })
            }
          </div>
          <div  className="title">
                我们的优势
          </div>
          <div className="good">
            {
              this.state.data02.map((item,index)=>{
                return (
                    <div className="goodContainer" style={{maxWidth:"18rem"}} >
                      <img src={item.img} style={{width:"18rem",marginTop:"0.5rem"}}/>
                      <div className="title" style={{margin:"0.5rem 0 0.5rem 0",fontSize:"0.8rem"}}>{item.title}</div>
                      {
                        item.intro.map((item,index)=>{
                          return(
                            <div style={{display:"flex",textAlign:"left",maxWidth:"18rem"}}>
                              <div style={{color:"#447eeb",whiteSpace:"nowrap",marginRight:"0.5rem"}}>{item.sub}</div>
                              <div style={{color:"rgb(153,166,188)"}}>{item.intro01}</div>
                            </div>
                          );
                        })
                      }
                    </div>
                );
              })
            }
          </div>
          <div  className="title">
                我们的服务
          </div>
          < div className="companylogo">
            <img src={require('../image/logo/mengduo.svg')} className="company01"></img>
            <img src={require('../image/logo/kute.svg')} className="company01"></img>
            <img src={require('../image/logo/haisibao.svg')} className="company01"></img>
            <img src={require('../image/logo/longsheng.svg')} className="company01"></img>
            <img src={require('../image/logo/hair.svg')} className="company01"></img>
            <img src={require('../image/logo/yutong.svg')} className="company01"></img>
            <img src={require('../image/logo/haichuanghui.svg')} className="company01"></img>
          </div>
        </div>
      }{
        !global.constants.isMobile&&
        <div className="container2">
          <div className="title01">
                <div className="titleAll">
                  <div className="title01-1" >解决方案</div>
                  <div className="title01-2">/SOLUTION</div>
                </div>
                <div className="title01-3">提供全套的软硬件解决方案,无论是服装定制店,健身房,私人裁缝,都<br/>
                可以找到适合你的应用场景.</div>
          </div>
          <div className="tag-container">
            {
              this.state.data.map((item,index)=>{
                return (
                    <div key={index} className="box1">
                      <img src={item.img1} className="logo01" style={{marginTop:(index===3?"10px":"20px")}}/>
                      <div className="title02-1">{item.title}</div>
                      <div className="intro02-1">{item.intro}</div>
                      <div className="button01">
                        <img src={global.constants.channel==="mengduo"? require('../image/mengduo/book.svg'):require('../image/book.svg')} className="book"></img>
                        <div className="liaojie">了解更多</div>
                        <img src={global.constants.channel==="mengduo"? require('../image/mengduo/arrow.svg'):require('../image/jiantou.svg')} className="jiantou"></img>
                      </div>
                    </div>  
                );
              })
            }
          </div>
        </div>
      }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/second.js